import { getStoredLoginIdentifier } from '../auth/sessionToken';

/** Per-account localStorage suffix so profile hints survive logout on the same device. */
export function profileStorageAccountSuffix(loginId?: string | null): string {
  const id = (loginId ?? getStoredLoginIdentifier())?.trim().toLowerCase();
  return id || 'anonymous';
}

export function profileStorageKey(prefix: string, loginId?: string | null): string {
  return `${prefix}:${profileStorageAccountSuffix(loginId)}`;
}
